/**
 * @file Renders the mobile contact-us button and the modal it opens.
 */
import type { ReactNode } from "react";
import { FloatButton, Modal } from "antd";

const LABEL_CONTACT_US = "Need help? Contact us.";

type Props = {
  icon: ReactNode;
  isOpen: boolean;
  onClick: () => void;
  children: ReactNode;
};

/**
 * Renders the floating contact-us button and the modal that its clicks
 * open on a mobile viewport.
 */
const ContactUsMobile = ({
  icon,
  isOpen,
  onClick,
  children,
}: Props): JSX.Element => {
  const type = "default";
  const shape = "square";
  const className = "contact-us-mobile";

  return (
    <>
      <FloatButton
        icon={icon}
        type={type}
        shape={shape}
        onClick={onClick}
        className={className}
        description={LABEL_CONTACT_US}
      />

      <Modal
        open={isOpen}
        footer={null}
        onCancel={onClick}
        maskClosable={false}
      >
        {children}
      </Modal>
    </>
  );
};

export default ContactUsMobile;
